import React, { useState, useEffect } from 'react';

import { TimeBox, TimeDivision, useStyles } from './RoleInformation.styles';
import { Box, Grid } from '@material-ui/core';
import { ClockCircleIcon, Typography } from '@room-match/shared-ui-components';
import { IProject } from 'shared/interfaces/IProject';
import 'moment-timezone';
import { COLORS } from 'shared/constants/COLORS';
import { timeParser } from 'shared/utils/timeHelpers';
import { CustomTypography } from 'shared/elements/CustomTypography';

interface Props {
  projectData?: IProject;
  dueDate?: string;
  timezone?: string;
  time?: string;
}

//TODO remove timezone
const RoleInformation: React.FC<Props> = ({ projectData, dueDate, timezone = 'AU', time }) => {
  const [remaining, setremaining] = useState<string>('');

  const classes = useStyles();

  useEffect(() => {
    setremaining(timeParser(dueDate || '', time || '', timezone || ''));
  }, [dueDate, timezone, time]);

  return (
    <Grid className={classes.root}>
      <Grid item className={classes.left}>
        {dueDate ? (
          <TimeDivision>
            <TimeBox>
              <ClockCircleIcon
                style={{ marginTop: 5 }}
                htmlColor={remaining.includes('D') ? COLORS.PRIMARY : COLORS.DANGER}
              />

              <Box style={{ display: 'flex', flexDirection: 'column', marginLeft: 10 }}>
                {remaining == 'Late' ? (
                  <Typography fontSize={15} style={{ textAlign: 'center', color: '#e53737' }}>
                    Late
                  </Typography>
                ) : (
                  <CustomTypography fontSize={15} style={{ textAlign: 'center' }}>
                    {remaining}
                  </CustomTypography>
                )}
                <CustomTypography fontSize={12} style={{ letterSpacing: 0.32, marginTop: -5 }}>
                  Due Time
                </CustomTypography>
              </Box>
            </TimeBox>
          </TimeDivision>
        ) : (
          <>No Due Date</>
        )}
      </Grid>
    </Grid>
  );
};

export default RoleInformation;
